/**
 * Hero Section
 */

class Hero {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Section initialization
    console.log('Hero section initialized');
  }
}

// Initialize section when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHero);
} else {
  initHero();
}

function initHero() {
  const sections = document.querySelectorAll('[data-section-type="hero"]');
  sections.forEach((section) => {
    new Hero(section);
  });
}

// Shopify section events
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId && event.target.querySelector('[data-section-type="hero"]')) {
      new Hero(event.target.querySelector('[data-section-type="hero"]'));
    }
  });
}
